import React from 'react';

import { LegacyText } from '@gogame/components';
import { DateValueFormatter } from '@gogame/intl-ts';

const STATUS_MAP = {
  error: 'error',
  warning: 'warning',
  completed: 'success',
};

const Message = ({ type, date, children }) => {
  const props = {};

  if (STATUS_MAP[type]) {
    props.type = STATUS_MAP[type];
  }

  return (
    <LegacyText {...props} style={{ padding: '8px 0' }}>
      <DateValueFormatter value={date} template={'LLLL'} timeZone={'local'} />
      <span style={{ marginLeft: '8px' }}>{children}</span>
    </LegacyText>
  );
};

export default Message;
